var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Log',{attrs:{"sousuo":true,"columns":_vm.columns,"xiangqing":true},on:{"showData":_vm.getRow,"getData":_vm.init,"deleteOpe":_vm.deleteSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }